<template>
  <!-- the container for the recent bidding history -->
  <div class="messageOverflowWrapper">
    <!-- the header for the information in -->
    <div class="bidHistoryHeader">
      <!-- the title in the header -->
      <span
        v-if="biddingHistory.length > 0"
        class="understatedText"
      >
        Recent 

        <!-- nice transition between link states -->
        <transition
          name="fade"
          mode="out-in"
        >
          <span v-if="showBidHistoryLink">
            <a :href="'/items/' + item_id + '/bids/'">
              bidding activity
            </a>
          </span>
          <span v-else>
            bidding activity
          </span>
        </transition>
        :
      </span>
    </div>

    <!-- the container that holds the actual messages -->
    <div class="messageBubbleContainer">
      <!-- loop through all of the recent bidding history we have -->
      <div
        v-for="(message, key) in biddingHistory"
        v-if="message.message !== null && !itemBiddingStatus.has_sold && !itemBiddingStatus.has_passed"
        :key="key"
        :class="{ messageAnimate: (key === biddingHistory.length - 1), messageBubbleSlider: true }"
      >
        <!-- show the message -->
        <div class="messageBubble">
          {{ message.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BiddingMessages',
  props: [
    'item_id'
  ],
  data () {
    return {
		'biddingHistory': {
			'message': '',
			'timestamp': ''
		}
	}
  },
  computed: {
	itemBiddingStatus: function () {
		return this.$store.getters.itemBiddingStatus(this.item_id)
	},
    showBidHistoryLink: function () {
		if (typeof this.$store.getters.biddingHistories['ITEMID_' + this.item_id] === 'undefined') {
			return false
		}
		return this.$store.getters.biddingHistories['ITEMID_' + this.item_id].length > 4
    },
    storeBiddingHistory: function () {
		return this.$store.getters.biddingHistories['ITEMID_' + this.item_id]
    },
    customer: function () {
		return this.$store.getters.customer
    }
  },
  watch: {
    storeBiddingHistory: function () {
		this.recomputeBiddingHistory()
    }
  },
  methods: {

    recomputeBiddingHistory: function () {

      if (this.$store.getters.biddingHistories['ITEMID_' + this.item_id]) {

        let filteredArray = []
        let storedIds = []

        for (var i = 0; i < this.$store.getters.biddingHistories['ITEMID_' + this.item_id].length; i++) {
          if (storedIds.indexOf(this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].id) === -1) {
            let pushArray = {
              'id': '',
              'message': '',
              'timestamp': '',
              'bidCard': ''
            }
            pushArray.id = this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].id
            pushArray.message = this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].message
            pushArray.timestamp = this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].timestamp
            pushArray.bidCard = this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].bid_card
            if (
              this.customer.bid_cards[this.itemBiddingStatus.auction_id] &&
              this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].message !== null
            ) {
              let bidCard = this.customer.bid_cards[this.itemBiddingStatus.auction_id]
              let bidcardString = 'Bidder #' + bidCard + ' has'
              let superceededString = 'Bidder #' + bidCard + ' submitted'
              pushArray.message = this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].message.replace(superceededString, 'You (#' + bidCard + ') submitted')
              pushArray.message = pushArray.message.replace(bidcardString, 'You (#' + bidCard + ') have')
              pushArray.message = pushArray.message.replace('You now has the bid', 'You (#' + bidCard + ') are the current high bidder')
              pushArray.message = pushArray.message.replace('You has the bid', 'You (#' + bidCard + ') are the current high bidder')
            }
            if (
              (
                pushArray.message === 'Bidding for this lot has closed.' ||
                pushArray.message === 'Bidding is now open for this lot.'
              ) &&
              (
                pushArray.bidCard === this.customer.bid_cards[this.itemBiddingStatus.auction_id]
              )
            ) {
            } else {
              filteredArray.push(pushArray)
            }

            storedIds.push(this.$store.getters.biddingHistories['ITEMID_' + this.item_id][i].id)
          }
        }
        this.biddingHistory = filteredArray
      }
    }
  }
}
</script>

<style scoped>
</style>
